import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FormattedMessage} from 'react-intl';
import {Grid, Header, Container, Icon} from 'semantic-ui-react';
import setDisplayName from 'recompose/setDisplayName';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import isEmpty from 'lodash/isEmpty';
import {SitesByLanguage} from 'utils/DBUtils';
import TopRewardsPanel from './TopRewardsPanel';
import StorePickerPanel from './StorePickerPanel';
import {setLangAction, requestTopRewardsAction} from '../actions';
import {DEFAULT_LANG} from '../utils';
import SiteMenu from 'components/common/SiteMenu';

const mapStateToProps = state => {
  const {selectedLang, topRewards, storeEscrowsById} = state.rewards;
  return {
    // FIXME: uncomment this when topRewards for es-LA and en-GB are non-empty
    loading: /* isEmpty(topRewards) || */ isEmpty(storeEscrowsById),
    lang: selectedLang,
    topRewards
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  selectLang: setLangAction,
  fetchTopRewards: requestTopRewardsAction
}, dispatch);

const RewardsDashboard = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.fetchTopRewards(this.props.lang);

      if (!this.props.lang) {
        this.props.selectLang(DEFAULT_LANG);
      }
    }
  }),
  setDisplayName('RewardsDashboard')
)(props => (
  <div className='rewards-dashboard'>
    <Grid className='rewards-page-header'>
      <Grid.Row columns={2}>
        <Grid.Column>
          <Header as='h1'>
            <FormattedMessage id='rewardsStore.dashboard.page.header' />
          </Header>
        </Grid.Column>
        <Grid.Column textAlign='right'>
          <SiteMenu
            disabled={props.loading}
            lang={props.lang}
            selectLang={props.selectLang} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
    {props.loading ? (
      <Container textAlign='center' className='dashboard-loading-spinner'>
        <Icon loading name='spinner' size='huge' />
      </Container>
    ) : (
      <Grid className='rewards-dashboard-content'>
        <Grid.Row columns={2}>
          <Grid.Column>
            <TopRewardsPanel
              site={SitesByLanguage[props.lang]}
              topRewards={props.topRewards} />
          </Grid.Column>
          <Grid.Column>
            {/* this space intentionally left blank */}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2}>
          <Grid.Column>
            <StorePickerPanel />
          </Grid.Column>
          <Grid.Column>
            {/* this space intentionally left blank */}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )}
  </div>
));

export default RewardsDashboard;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsDashboard/RewardsDashboard.jsx